import React from 'react';
import { createRoot } from 'react-dom/client';
import { Route } from 'react-router-dom';
import { MMProvider, PrivateLayout } from '@machinemetrics/mm-react-tools';
import App from './App';
import Edges from './Edges';
import './index.css';

// Load the config at runtime
if (typeof window === 'undefined') {
  throw new Error('Configuration must be loaded in browser environment');
}

async function loadConfig() {
  try {
    const response = await fetch('/default.json');
    if (!response.ok) {
      throw new Error(`Failed to load configuration: ${response.status} ${response.statusText}`);
    }
    const config = await response.json();
    
    // Validate required config fields
    const requiredFields = ['domain', 'clientId', 'clientSecret', 'releaseStage'];
    const missingFields = requiredFields.filter(field => !config[field]);
    if (missingFields.length > 0) {
      throw new Error(`Missing required configuration fields: ${missingFields.join(', ')}`);
    }
    
    return config;
  } catch (error) {
    console.error('Error loading configuration:', error);
    throw error;
  }
}

async function initializeApp() {
  try {
    const config = await loadConfig();
    const root = createRoot(document.getElementById('root'));

    root.render(
      <MMProvider
        releaseStage={config.releaseStage}
        domain={config.domain}
        clientId={config.clientId}
        clientSecret={config.clientSecret}
        scope={'reporting'}
      >
        <Route element={<PrivateLayout />}>
          <Route path="/" element={<App />} />
          <Route path="/edges" element={<Edges />} />
        </Route>
      </MMProvider>
    );
  } catch (error) {
    // Show error in the UI
    const root = createRoot(document.getElementById('root'));
    root.render(
      <div style={{ 
        padding: '20px', 
        color: 'red', 
        textAlign: 'center',
        fontFamily: 'Arial, sans-serif'
      }}>
        <p>Failed to load application configuration.</p>
        <p>Please contact support if this issue persists.</p>
      </div>
    );
  }
}

// Start the application
initializeApp();